// After a new deploy, an already-open tab can still reference JS chunk
// hashes that no longer exist on the server (old build output was replaced).
// Any lazy-loaded route then fails with "Failed to fetch dynamically
// imported module". A single reload fetches the current index.html and
// resolves it; the sessionStorage guard stops a real outage from looping.
const RELOAD_GUARD_KEY = "sig_stale_chunk_reload_at";
const RELOAD_GUARD_WINDOW_MS = 10_000;

const STALE_CHUNK_PATTERN =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

export const isStaleChunkError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return STALE_CHUNK_PATTERN.test(message);
};

export const canReloadForStaleChunk = (): boolean =>
  Date.now() - Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0) >= RELOAD_GUARD_WINDOW_MS;

export const reloadOnceForStaleChunk = (): void => {
  if (!canReloadForStaleChunk()) return;

  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  window.location.reload();
};
